import React from "react";
import { Trans } from "react-i18next";
import styled from "styled-components/macro";

const Title = styled.div`
  font-size: 1.4rem;
  text-transform: uppercase;
  margin: 20px 0;
  line-height: 1.3;
`;

const Quiet = styled.div`
  // margin-top: -20px;
  margin-bottom: 40px;
  font-size: 0.9rem;
  line-height: 1.6;
`;

const SImg = styled.img`
  width: 80%;
  display: block;
  margin: 0 auto;
`;

const SaleMainSummer: React.FC = () => {
  return (
    <>
      <SImg src="https://cdn.duocards.com/mail/mother-lang-day.png" />
      <Title>Don't let your language goals fade away.</Title>
      <Quiet>
        <Trans>
          Make the most of summer’s final days and kickstart your learning with our biggest deal of the year — 60% off
          the yearly plan!
        </Trans>
      </Quiet>
    </>
  );
};

export default SaleMainSummer;
